export class LookupModel {
  readonly id: number;
  readonly name: string;
  readonly description?: string;
  readonly projectTypeId?: number;
  readonly projectStatus?: number;

  constructor(options: {
    id: number;
    name: string;
    description?: string;
    projectTypeId?: number;
    projectStatus?: number;
  }
  ) {
    this.id = options.id;
    this.name = options.name;
    this.description = options.description;
    this.projectTypeId = options.projectTypeId;
    this.projectStatus = options.projectStatus;
  }
}
